export default "__VITE_ASSET__HEzTLOAn__"